export const toggleReturnExchange = () => {
	$("[id^='returnTypes']").on('change', function () {
		var chkboxClicked = $(this);
		var infoBoxRow = $(this).parent().prop('id');
		var inputToUpdate = $(this).closest('div').siblings('input[id^="chkboxVal"]');
		if (chkboxClicked.is(':checked')) {
			$('#returnInfoRow' + infoBoxRow).show();
			inputToUpdate.val('R');
		} else {
			$('#returnInfoRow' + infoBoxRow).hide();
			inputToUpdate.val('');
		}
	});
};
